import React from 'react';
import { motion } from 'framer-motion';
import { Search, Map, Settings, Activity } from 'lucide-react';
const steps = [{
  num: '01',
  title: 'Diagnóstico',
  desc: 'Analizamos tu situación actual y detectamos oportunidades de crecimiento.',
  icon: Search
}, {
  num: '02',
  title: 'Estrategia',
  desc: 'Diseñamos un plan a medida integrando Ads, IA y CRM.',
  icon: Map
}, {
  num: '03',
  title: 'Implementación',
  desc: 'Ejecutamos las campañas y configuramos las automatizaciones.',
  icon: Settings
}, {
  num: '04',
  title: 'Optimización Continua',
  desc: 'Medimos, ajustamos y escalamos los resultados mes a mes.',
  icon: Activity
}];
export function Process() {
  return <section id="proceso" className="py-24 bg-slate-900 text-white overflow-hidden" data-id="element-189">
      <div className="container mx-auto px-6 md:px-12" data-id="element-190">
        <div className="text-center mb-20" data-id="element-191">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl md:text-4xl font-bold mb-4 text-white" data-id="element-192">
            Cómo trabajamos
          </motion.h2>
          <div className="w-20 h-1 bg-brand-cyan mx-auto rounded-full" data-id="element-193" />
        </div>

        <div className="relative" data-id="element-194">
          {/* Connecting Line (Desktop) */}
          <div className="hidden lg:block absolute top-1/2 left-0 w-full h-[1px] bg-slate-800 -translate-y-1/2" data-id="element-195" />

          <div className="grid lg:grid-cols-4 gap-12 lg:gap-6" data-id="element-196">
            {steps.map((step, index) => {
            const Icon = step.icon;
            return <motion.div key={step.num} initial={{
              opacity: 0,
              y: 30
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.5,
              delay: index * 0.15
            }} className="relative z-10 flex flex-col items-center text-center group" data-id="element-197">
                  <div className="w-16 h-16 rounded-2xl bg-slate-800 border border-slate-700 flex items-center justify-center mb-6 group-hover:bg-brand-cyan group-hover:border-brand-cyan transition-colors duration-300 shadow-lg" data-id="element-198">
                    <Icon size={28} className="text-slate-300 group-hover:text-brand-black transition-colors duration-300" data-id="element-199" />
                  </div>

                  <div className="text-brand-cyan font-bold text-sm mb-2 tracking-widest" data-id="element-200">
                    PASO {step.num}
                  </div>
                  <h3 className="text-xl font-bold mb-3 text-white" data-id="element-201">
                    {step.title}
                  </h3>
                  <p className="text-slate-400 text-sm leading-relaxed max-w-[250px]" data-id="element-202">
                    {step.desc}
                  </p>
                </motion.div>;
          })}
          </div>
        </div>
      </div>
    </section>;
}